module.exports = __webpack_public_path__ + "static/media/success-icon.1d5d1ecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/success-icon.png
// module id = 1983
// module chunks = 6